<!--Login Page Starts-->
<section id="login" class="bg-cage">
  <div class="container-fluid">
    <div class="row full-height-vh">
      <div class="col-md-6 col-xs-12 left-column" [style.background-image]="'url(' + event.eventbackgroundUrl + ')'"></div>
      <div class="col-md-6 col-xs-12 align-items-center justify-content-center" style="background-color: #F2F2F2">
        <div class="img-mobile">
          <img [src]="event.eventBackgroundMobileUrl" width="100%" height="auto">
        </div>
        <div class="logo-container">
          <img [src]="event.eventLogoUrl" width="141px">
        </div>
        <div class="card-container">
          <div class="card text-center width-400">
            <div class="card-body">
              <div class="card-block">
                <h1>Recupera password</h1>
                <form [formGroup]="regularForm" (ngSubmit)="reset()">
                  <div class="form-group" style="margin-bottom: 16px">
                    <div class="col-md-12">
                      <input type="email" class="form-control form-control-login" name="username" id="username" formControlName="username" placeholder="Inserisci la tua mail">
                    </div>
                  </div>
                  <div class="col-md-12">
                    <button type="submit" class="btn btn-primary full-width" [disabled]="!regularForm.valid">Conferma</button>
                  </div>
                </form>
              </div>
              <div class="card-footer" style="padding-bottom: 0">
                <div class="text-center"><a routerLink="/login"><p>Torna alla login</p></a></div>
              </div>
            </div>
          </div>
        </div>
        <div class="contatti text-center footer-absolute" style="padding-top: 1rem; color: white">
          <div [innerHTML]="event.eventFooter"></div>
        </div>
      </div>
    </div>
  </div>
</section>
<!--Login Page Ends-->
